import { render } from "./SocialNetwork.vue?vue&type=template&id=2fabdf42&scoped=true"
import script from "./SocialNetwork.vue?vue&type=script&lang=js"
export * from "./SocialNetwork.vue?vue&type=script&lang=js"

import "./SocialNetwork.vue?vue&type=style&index=0&id=2fabdf42&lang=scss&scoped=true"

import exportComponent from "F:\\PROMODUL\\Projets\\APP.RESPIRE\\code\\respire\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fabdf42"]])

export default __exports__